import { GetterTree } from "vuex";
import { RootState } from "../types";
import { CourseState } from "./types";

export const getters: GetterTree<CourseState, RootState> = {};
